export const flash = {
  data() {
    return {
      showError: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      dismissCountDownError: 0,
    };
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    countDownChangedError(dismissCountDown) {
      this.dismissCountDownError = dismissCountDown;
    },
    flashSuccess() {
      this.dismissCountDown = this.dismissSecs;
    },
    flashError() {
      this.dismissCountDownError = this.dismissSecs;
    },
  },
};
